var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('password',{ref:"password"}),_c('second-factor',{attrs:{"active":_vm.confirmByOTPModal},on:{"update:active":function($event){_vm.confirmByOTPModal=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }